import React from 'react';
import {
    Alert,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Switch,
    Typography,
    CircularProgress,
} from '@mui/material';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ReconciliationEmailDialogProps } from './auditReportsTypes';
import { DatePickerWrapper } from './styledComponents';
import {
    adminAlertSx,
    adminAlertToneSx,
    adminButtonSx,
    adminButtonToneSx,
    adminCombineSx,
    adminDialogActionsSx,
    adminDialogContentSx,
    adminDialogSx,
    adminDialogTitleSx,
} from '../../styles/adminComponentStyles';
import { adminColors, adminTypography } from '../../styles/adminDesignTokens';

const ReconciliationEmailDialog: React.FC<ReconciliationEmailDialogProps> = ({
    open,
    onClose,
    reconcileDate,
    onChangeDate,
    forceResend,
    onForceResendChange,
    sending,
    responseMessage,
    onSend,
    storeId,
    onClearResponseMessage,
}) => (
    <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        maxWidth="sm"
        PaperProps={{
            sx: adminCombineSx(adminDialogSx, { minHeight: 420 }),
        }}
    >
        <DialogTitle sx={adminDialogTitleSx}>
            Send Reconciliation Email
        </DialogTitle>
        <DialogContent sx={adminCombineSx(adminDialogContentSx, { display: 'flex', flexDirection: 'column', gap: 2 })}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <Typography sx={{ ...adminTypography.bodyStrong, color: adminColors.text, mb: 1, display: 'block' }}>
                    Report Date
                </Typography>
                <DatePickerWrapper>
                    <ReactDatePicker
                        selected={reconcileDate}
                        onChange={(date: Date | null) => onChangeDate(date)}
                        maxDate={new Date()}
                        inline
                    />
                </DatePickerWrapper>

                <FormControlLabel
                    control={<Switch checked={forceResend} onChange={(event) => onForceResendChange(event.target.checked)} />}
                    label="Force resend email"
                />
            </Box>

            {responseMessage && (
                <Alert
                    severity={responseMessage.type}
                    onClose={onClearResponseMessage}
                    sx={adminCombineSx(adminAlertSx, adminAlertToneSx[responseMessage.type === 'error' ? 'danger' : 'success'])}
                >
                    {responseMessage.text}
                </Alert>
            )}
        </DialogContent>
        <DialogActions sx={adminDialogActionsSx}>
            <Button
                onClick={onClose}
                disabled={sending}
                size="small"
                variant="outlined"
                sx={adminCombineSx(adminButtonSx, adminButtonToneSx.secondary)}
            >
                Close
            </Button>
            <Button
                variant="contained"
                onClick={onSend}
                disabled={sending || !reconcileDate || !storeId}
                startIcon={sending ? <CircularProgress size={18} color="inherit" /> : undefined}
                size="small"
                sx={adminCombineSx(adminButtonSx, adminButtonToneSx.primary)}
            >
                {sending ? 'Sending…' : 'Send Email'}
            </Button>
        </DialogActions>
    </Dialog>
);

export default ReconciliationEmailDialog;
